const baseUrl = '/payment/api/'; // NOTE: redundant defines on request service creation
const stripeBaseUrl = 'stripe';
const payoutBaseUrl = 'payout';
const feeBaseUrl = 'fee';
export const paymentRoutes = {
  autopayMethod: 'stripe/autopay-method',
  // NOTE: for aggregate api
  baseUrl: "".concat(baseUrl),
  coupon: 'stripe/coupon',
  balance: accountId => "accountbalance/balance/".concat(accountId),
  deleteSubscription: subscriptionId => "stripe/subscription/".concat(subscriptionId),
  finalStatement: 'finalstatement',
  getFSEInfos: 'finalstatement/get-fse-infos',
  stripeinvoice: 'stripeinvoice',
  getInvoices: 'stripeinvoice/company-invoices',
  getInvoicesV2: 'stripeinvoice/company-invoices-v2',
  getUpcomingInvoices: 'stripeinvoice/company-upcoming-invoices',
  postRefundOrCredit: 'stripeinvoice/refund-credit',
  postUndoRefund: 'stripeinvoice/undo-refund',
  finalStatementSubmit: 'finalstatement/submit',
  paymentMethod: 'stripe/company-payment-method',
  paymentSummary: 'stripe/subscription/summary-v2',
  publickey: 'stripe/publickey',
  setupIntentWithAutopay: 'stripe/setup-intent-with-autopay',
  setupIntent: 'stripe/setup-intent',
  setupIntentWithCoupon: 'stripe/setup-intent-coupon',
  setupIntentWithSubscription: 'stripe/setup-intent-with-subscription',
  subscription: 'stripe/subscription',
  products: "".concat(stripeBaseUrl, "/products"),
  priceTiers: stripeProductId => "".concat(stripeBaseUrl, "/price/").concat(stripeProductId, "/tiers"),
  product: "".concat(stripeBaseUrl, "/product"),
  // NOTE: Payout start
  achDirectDeposit: "".concat(payoutBaseUrl, "/ach-direct-deposit"),
  payoutMethods: "".concat(payoutBaseUrl, "/payout-methods"),
  postPayoutMethod: "".concat(payoutBaseUrl, "/payout-method"),
  assignPayoutMethod: "".concat(payoutBaseUrl, "/assign-payout-method"),
  companyAchDirectDeposit: "".concat(payoutBaseUrl, "/company/ach-direct-deposit"),
  regularCheck: "".concat(payoutBaseUrl, "/regular-check"),
  companyRegularCheck: "".concat(payoutBaseUrl, "/company/regular-check"),
  // NOTE: Payout end
  residentTransactionHistory: "transactionhistoryv2/account-history",
  transactionHistoryV2Listing: "transactionhistoryv2/list",
  autopayByAccountId: accountId => "".concat(stripeBaseUrl, "/autopay-method/").concat(accountId),
  balanceRemainder: accountId => "accountbalance/balance-remainder/".concat(accountId),
  balanceRemainderToMultipleAccounts: "accountbalance/balance-remainder",
  propertyFee: "".concat(feeBaseUrl, "/property-fee"),
  batchResidencyFee: "".concat(feeBaseUrl, "/batch-residency-fee"),
  batchGetResidencyFee: "".concat(feeBaseUrl, "/batch-get-residency-fee"),
  residencyFee: "".concat(feeBaseUrl, "/residency-fee"),
  paperUsage: "".concat(stripeBaseUrl, "/paper-usage"),
  propertyPaymentMethod: "".concat(stripeBaseUrl, "/property-payment-method"),
  propertyPaymentMethodById: propertyId => "".concat(stripeBaseUrl, "/property-payment-method/").concat(propertyId),
  stripeProducts: "".concat(stripeBaseUrl, "/product"),
  setupIntentWithReplace: "".concat(stripeBaseUrl, "/setup-intent-with-replace"),
  billingSchedule: "billingschedule",
  paymentSettingsBaseUrl: residencyId => "paymentsettings/".concat(residencyId),
  stripesubscription: "stripesubscription"
};